import { Pipe, PipeTransform } from '@angular/core';
import { round } from 'src/app/common-components/utils/rounding';

@Pipe({
    name: 'durationToRelativeFormat',
    standalone: false
})
export class DurationToRelativeFormatPipe implements PipeTransform {
   transform(value: number | null, precision: number | null = null): string | null {
      return durationToRelativeFormatTransform(value, precision);
   }
}

export function durationToRelativeFormatTransform(
   totalSeconds: number | null,
   precision: number | null = null
): string | null {
   if (totalSeconds === null) return null;

   if (totalSeconds < 60) {
      return `${precision === null ? totalSeconds : round(totalSeconds, precision)}s`;
   } else {
      const totalMinutes: number = Math.floor(totalSeconds / 60);
      const seconds: number = totalSeconds - totalMinutes * 60;
      const secondsString = seconds > 0 ? ` ${precision === null ? seconds : round(seconds, precision)}s` : '';
      if (totalMinutes < 60) {
         return `${precision === null ? totalMinutes : round(totalMinutes, precision)}m${secondsString}`;
      } else {
         const hours: number = Math.floor(totalMinutes / 60);
         const minutes: number = totalMinutes - hours * 60;
         return `${precision === null ? hours : round(hours, precision)}h ${
            precision === null ? minutes : round(minutes, precision)
         }m${secondsString}`;
      }
   }
}
